import styled from 'styled-components';

import {THEME} from '../../common/css/color.styles';

export const PopupContent = styled.div`
  padding: 16px;
`;

export const Label = styled.div`
  margin-bottom: 8px;
  font-weight: 600;
`;

export const FilterControls = styled.div`
  width: 100%;
  position: absolute;
  z-index: 9;
  background: ${THEME.bgSurfaceRaised};
  border-bottom: 2px solid light-dark(#bbb, var(--moon-650));
  padding: 5px;
  top: 30px;
  display: flex;
  flex-direction: column;
`;
